<template>
  <div class="video-cards">
    <div class="cards-track">
      <!-- First set of cards -->
      <div class="video-card" v-for="(card, index) in cards" :key="index">
        <video autoplay muted loop playsinline class="card-video">
          <source :src="card.videoSrc" type="video/mp4" />
        </video>
        <div class="card-overlay">
          <div class="card-content">
            <h3 v-html="card.title"></h3>
          </div>
        </div>
      </div>

      <!-- Duplicate set for infinite scroll -->
      <div
        class="video-card"
        v-for="(card, index) in cards"
        :key="'dup-' + index"
      >
        <video autoplay muted loop playsinline class="card-video">
          <source :src="card.videoSrc" type="video/mp4" />
        </video>
        <div class="card-overlay">
          <div class="card-content">
            <h3 v-html="card.title"></h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VideoCards",
  data() {
    return {
      cards: [
        {
          videoSrc: "/assets/videos/istanbul.mp4",
          title: "Istanbul<br />Historical Peninsula",
        },
        {
          videoSrc: "/assets/videos/paris.mp4",
          title: "Paris<br />City of Lights",
        },
        {
          videoSrc: "/assets/videos/rome.mp4",
          title: "Rome<br />Eternal City",
        },
      ],
    };
  },
};
</script>
